import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "./api.request";

const SUPPLIER_PATH = "/supplier/v1";

// Get all suppliers with pagination and search
export const getSupplierApi = async (params) => await getRequest(SUPPLIER_PATH, params);

// Get supplier by ID
export const getSupplierByIdApi = async (id) => await getRequest(`${SUPPLIER_PATH}/${id}`);

// Create new supplier
export const createSupplierApi = async (body) => await postRequest(SUPPLIER_PATH, body);

// Update supplier
export const updateSupplierApi = async (id, body) => await putRequest(`${SUPPLIER_PATH}/${id}`, body);

// Delete supplier (soft delete)
export const deleteSupplierApi = async (id) => await deleteRequest(`${SUPPLIER_PATH}/${id}`);

// Get active suppliers for dropdown
export const getActiveSuppliersApi = async () => await getRequest(`${SUPPLIER_PATH}/active`);

export const addSupplierApi = async (data) => await postRequest(SUPPLIER_PATH, data);

export const deleteSupplierByIdApi = async (id) => await deleteRequest(`${SUPPLIER_PATH}/${id}`); 